import config from "../../app.json";
import axios from "axios";

import { Context } from "../../Reducers/Store";
import React, { useEffect, useState, useContext } from "react";
import ChurchInfoBranding from "../../Components/ChurchInfoBranding";
import ChurchInfoAwsConnection from "../../Components/ChurchInfoAwsConnection";
import ChurchInfoColor from "../../Components/ChurchInfoColor";
import AlertComponent from "../../Components/AlertComponent";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import CsWhiteLogo from "../../Assets/Svgs/cs-white-logo.svg";
import AwsLogo from "../../Assets/Svgs/aws-logo.svg";

function Branding() {
  const [state, dispatch] = useContext(Context);

  // Branding Info
  const [churchName, setChurchName] = useState(null);
  const [churchAddress, setChurchAddress] = useState(null);
  const [fullLogo, setFullLogo] = useState(null);
  const [fullLogoError, setFullLogoError] = useState(null);
  const [logoSymbol, setLogoSymbol] = useState(null);
  const [logoSymbolError, setLogoSymbolError] = useState(null);
  const [timezone, setTimezone] = useState(null);
  const [timezones, setTimezones] = useState([]);

  const [city, setCity] = useState(null);
  const [churchState, setChurchState] = useState(null);
  const [zipCode, setZipCode] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  // Aws Info
  const [awsKeyId, setAwsKeyId] = useState(null);
  const [awsSecretKey, setAwsSecretKey] = useState(null);

  // Color info
  const [primary, setPrimary] = useState(null);
  const [secondary, setSecondary] = useState(null);
  const [tertiary, setTertiary] = useState(null);
  const [fontPrimary, setFontPrimary] = useState(null);
  const [fontSecondary, setFontSecondary] = useState(null);
  const [fontTertiary, setFontTertiary] = useState(null);
  const [allowSelectSubscription, setAllowSelectSubscription] = useState(false);

  // Branding control
  const [newFile, setNewFile] = useState(null);
  const [hasError, setHasError] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    axios.post(config.API + "/api/general/getTimezones").then((resTimezones) => {
      if (resTimezones.status === 200 && resTimezones.data) {
        setTimezones(resTimezones.data.$values);

        axios.post(config.API + "/api/church/getBasicChurch").then((res) => {
          const data = res.data;
          dispatch({ type: "SET_CHURCH", payload: data });

          if (res.data) {
            setChurchName(data.name);
            setTimezone(data.timezone);
            setChurchAddress(data.address);
            setCity(data.city);
            setChurchState(data.state);
            setZipCode(data.zipCode);
            data.logo.preview = getPhotoPreviewUri(data.logo.guidFile);
            setFullLogo([data.logo]);
            data.smallLogo.preview = getPhotoPreviewUri(data.logo.guidFile);
            setLogoSymbol([data.smallLogo]);

            setPrimary(data.primaryColor);
            setSecondary(data.secondaryColor);
            setTertiary(data.tertiaryColor);

            setFontPrimary(data.primaryFontColor);
            setFontSecondary(data.secondaryFontColor);
            setFontTertiary(data.tertiaryFontColor);
          }
        }).catch(function (error) {
          return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
        });
      }
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  }, [0]);

  useEffect(() => {
    const allFieldsFilled =
      churchName &&
      churchAddress &&
      city &&
      churchState &&
      zipCode &&
      fullLogo &&
      logoSymbol &&
      awsKeyId &&
      awsSecretKey &&
      primary &&
      tertiary &&
      tertiary &&
      fontPrimary &&
      fontSecondary &&
      fontTertiary;

    setAllowSelectSubscription(allFieldsFilled);
  }, [
    churchName,
    churchAddress,
    fullLogo,
    logoSymbol,
    awsKeyId,
    awsSecretKey,
    primary,
    tertiary,
    tertiary,
    fontPrimary,
    fontSecondary,
    fontTertiary,
  ]);

  const getPhotoPreviewUri = (id) => {
    if (id) {
      return config.API + `/api/file/download/?guid=${id}`;
    }
    return null;
  };

  const uploadImage = async (file, setFile, formData) => {
    const optionsUpload = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    let logoFile = null;
    await axios.post(config.API + "/api/file/upload", formData, optionsUpload).then((res) => {
      let newUpload = res.data;
      delete newUpload.$id;
      newUpload.preview = file[0].preview;
      setFile([newUpload]);
      setNewFile(false);
      logoFile = newUpload;
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
    return logoFile;
  };

  const uploadFullLogo = async () => {
    const formDataFullLogo = new FormData();
    formDataFullLogo.append("file", fullLogo[0]);

    const fullLogoUpload = await uploadImage(
      fullLogo,
      setFullLogo,
      formDataFullLogo
    );

    return fullLogoUpload;
  };

  const uploadLogoSymbol = async () => {
    const formDataLogoSymbol = new FormData();
    formDataLogoSymbol.append("file", logoSymbol[0]);

    const logoSymbolUpload = await uploadImage(
      logoSymbol,
      setLogoSymbol,
      formDataLogoSymbol
    );

    return logoSymbolUpload;
  };

  const uploadFile = async () => {
    if (!fullLogo || !fullLogo.length) {
      return AlertComponent("Error", "Full Logo is required.", {
        icon: `error`,
      });
    }

    if (!logoSymbol || !logoSymbol.length) {
      return AlertComponent("Error", "Logo Symbol is required.", {
        icon: `error`,
      });
    }

    if (newFile) {
      if (newFile === "both") {
        const fullLogoUpload = await uploadFullLogo();
        const logoSymbolUpload = await uploadLogoSymbol();

        if (!fullLogoUpload || !logoSymbolUpload) {
          return AlertComponent(
            "Error",
            "Full Logo and Logo Symbol are required.",
            {
              icon: `error`,
            }
          );
        }

        saveData(fullLogoUpload, logoSymbolUpload);
      } else if (newFile === "FullLogo") {
        const fullLogoUpload = await uploadFullLogo();

        if (!fullLogoUpload) {
          return AlertComponent("Error", "Full Logo is required.", {
            icon: `error`,
          });
        }
      } else {
        const logoSymbolUpload = await uploadLogoSymbol();

        if (!logoSymbolUpload) {
          return AlertComponent("Error", "Logo Symbol is required.", {
            icon: `error`,
          });
        }
      }
    } else saveData(fullLogo?.at(0), logoSymbol?.at(0));
  };

  const getPayload = (logo, smallLogo) => {
    return {
      name: churchName,
      address: churchAddress,
      city: city,
      state: churchState,
      zipCode: zipCode,
      primaryColor: primary,
      secondaryColor: secondary,
      tertiaryColor: tertiary,
      primaryFontColor: fontPrimary,
      secondaryFontColor: fontSecondary,
      tertiaryFontColor: fontTertiary,
      awsAccessKey: awsKeyId,
      awsSecretKey,
      logo,
      smallLogo,
      timezone: timezone.value,
    };
  };

  const saveData = async (fullLogoParam, logoSymbolParam) => {
    const payload = getPayload(fullLogoParam, logoSymbolParam);

    await axios.post(config.API + `/api/church/saveChurch`, payload).then((res) => {
      AlertComponent("Success", "Data Saved");
      dispatch({ type: "SET_CHURCH", payload: res.data });
      return navigate("/selectPlan", { replace: false });
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  const handleLogout = () => {
    dispatch([{ type: "SET_LOGGED", payload: null }, { type: "SET_CHURCH", payload: null }]);
    navigate("/", { replace: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setHasError(false);

    if (!fullLogo) {
      setFullLogoError("Full logo is required");
      setHasError(true);
    } else {
      setFullLogoError(null);
    }

    if (!logoSymbol) {
      setLogoSymbolError("Logo symbol is required");
      setHasError(true);
    } else {
      setLogoSymbolError(null);
    }

    if (!hasError) {
      uploadFile();
    }
  };

  const changFullLogo = (value) => {
    if (newFile) {
      setNewFile("both");
    } else {
      setNewFile("FullLogo");
    }
    setFullLogo(value);
  };

  const changLogoSymbol = (value) => {
    if (newFile) {
      setNewFile("both");
    } else {
      setNewFile("LogoSymbol");
    }
    setLogoSymbol(value);
  };


  return (
    state.churchLoaded && (
      <div className="branding-container">
        <div className="containerBrandingForm">
          <form onSubmit={handleSubmit}>
            <Row className="header-login">
              <Col className="col-md-6">
                <img className="cs-logo-login" src={CsWhiteLogo} />
              </Col>
              <Col className="col-md-6">
                <img className="aws-logo-login" src={AwsLogo} />
              </Col>
            </Row>
            <Row>
              <Col className="col-md-3">
                <Row>
                  <div className="branding-church-info">
                    <ChurchInfoBranding
                      churchName={churchName}
                      setChurchName={setChurchName}
                      churchAddress={churchAddress}
                      // setChurchAddress={setChurchAddress}
                      fullLogo={fullLogo}
                      setFullLogo={changFullLogo}
                      logoSymbol={logoSymbol}
                      setLogoSymbol={changLogoSymbol}
                      fullLogoError={fullLogoError}
                      setFullLogoError={setFullLogoError}
                      logoSymbolError={logoSymbolError}
                      setLogoSymbolError={setLogoSymbolError}
                      timezone={timezone}
                      setTimezone={setTimezone}
                      timezones={timezones}
                      setChurchAddress={setChurchAddress}
                      setCity={setCity}
                      setState={setChurchState}
                      setZipCode={setZipCode}
                      setLatitude={setLatitude}
                      setLongitude={setLongitude}
                    />
                  </div>
                </Row>
                <Row>
                  <div className="branding-church-info">
                    <ChurchInfoAwsConnection
                      awsKeyId={awsKeyId}
                      setAwsKeyId={setAwsKeyId}
                      awsSecretKey={awsSecretKey}
                      setAwsSecretKey={setAwsSecretKey}
                    />
                  </div>
                </Row>
              </Col>
              <Col className="col-md-9">
                <Row>
                  <Col className="col-md-12">
                    <div className="branding-church-info">
                      <ChurchInfoColor
                        primary={primary}
                        setPrimary={setPrimary}
                        secondary={secondary}
                        setSecondary={setSecondary}
                        tertiary={tertiary}
                        setTertiary={setTertiary}
                        fontPrimary={fontPrimary}
                        setFontPrimary={setFontPrimary}
                        fontSecondary={fontSecondary}
                        setFontSecondary={setFontSecondary}
                        fontTertiary={fontTertiary}
                        setFontTertiary={setFontTertiary}
                        allowSelectSubscription={allowSelectSubscription}
                        fullLogoBlob={fullLogo?.at(0)?.preview}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-md-12">
                    <div className="form-group mt-3 buttonAlignBottomRight">
                      <button
                        type="submit"
                        className="btn submitLogout col-md-12"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    )
  );
}

export default Branding;
